/**
 * Join-flow tenant override.
 *
 * When a logged-in member joins *another* community, the join request and
 * its (optional) onboarding must be addressed to the **target** tenant —
 * not the one the session is currently in — without switching the active
 * session/branding. This mirrors how the Angular member-portal embedded
 * the join + onboarding with an explicit `X-Tenant-ID` header.
 *
 * While an override is set, the request interceptor stamps `x-tenant-id`
 * with this id instead of the active tenant. Set it on entering the join
 * flow, clear it on leaving. Lives in a leaf module (no store imports) so
 * the interceptor can read it without a cycle.
 *
 * NB: this overrides the tenant *identity* only — the regional API base
 * stays the session's region. That is correct for single-region SSO
 * deployments (the common case); cross-region joins would additionally
 * need the target's regional base resolved.
 */
let joinTenantId: string | null = null;

export function setJoinTenantContext(id: string | null | undefined): void {
  joinTenantId = (id ?? '').trim() || null;
}

export function getJoinTenantContext(): string | null {
  return joinTenantId;
}
